import React, { useEffect, useState } from "react";
import Services from "../../services/services";
import Title from "../../components/Title";
import SubscriptionPriceCard from "../../components/SubscriptionPriceCard";
import { handleGetFreemiumSubscription, RoutePages } from "../../ultils";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

const TIKTOK_CONCURRENCY_PLANS = [1, 10, 50];

const TikTokPricing = () => {
  const [plans, setPlans] = useState([]);
  const [customConcurrency, setCustomConcurrency] = useState(5);
  const [customPlan, setCustomPlan] = useState(null);
  const navigate = useNavigate();
  const userStore = useSelector((state) => state.auth.user);


  useEffect(() => {
    const fetchPlans = async () => {
      const promises = TIKTOK_CONCURRENCY_PLANS.map(async (concurrency) => {
        const res = await Services.Subscription.preview(
          "tiktok",
          null,
          null,
          concurrency
        );
        const data = await res.json();
        if (res.ok && data.success) {
          return { ...data.data, concurrency };
        }
        return null;
      });
      const results = await Promise.all(promises);
      setPlans(results.filter(Boolean));
    };
    fetchPlans();
  }, []);

  // Fetch custom plan when customConcurrency changes
  useEffect(() => {
    if (
      !customConcurrency ||
      isNaN(customConcurrency) ||
      customConcurrency < 1
    ) {
      setCustomPlan(null);
      return;
    }
    const fetchCustomPlan = async () => {
      const res = await Services.Subscription.preview(
        "tiktok",
        null,
        null,
        customConcurrency
      );
      const data = await res.json();
      if (res.ok && data.success) {
        setCustomPlan({ ...data.data, concurrency: customConcurrency });
      } else {
        setCustomPlan(null);
      }
    };
    fetchCustomPlan();
  }, [customConcurrency]);

  return (
    <div className="flex flex-col gap-5 p-2 sm:p-5 bg-gradient-to-br from-pink-100 via-white to-pink-100 min-h-screen">
      <Title page={RoutePages.PRICING.TIKTOK} title="Price Tiktok" />
      <h1 className="text-2xl font-bold text-center text-pink-600">
        TikTok Download API Pricing - Most Popular Plans
      </h1>

      {/* Sample TikTok Plans */}
      <div className="flex flex-col gap-4 items-center w-full">
        <p className="text-gray-500 mb-2 text-center max-w-2xl">
          Choose from popular plans below. Each plan is designed for a specific concurrency level.
        </p>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6 w-full max-w-7xl px-2">
          {/* Freemium Subscription Card */}
          <div className="flex flex-col gap-6 w-full min-w-[220px] max-w-xs mx-auto">
            {/* Documentation */}
            <div className="bg-white p-4 sm:p-6 rounded-2xl shadow border flex flex-col items-center h-full">
              <h2 className="text-2xl mb-3 font-bold text-center text-blue-600">
                Documentations
              </h2>
              <button
                onClick={() => window.open(RoutePages.DOCS.TIKTOK.path, "_blank")}
                className="px-4 py-3 text-white rounded-lg bg-blue-500 hover:bg-blue-700 w-full"
              >
                View Docs
              </button>
            </div>

            {/* Free Trial */}
            <div className="bg-white p-4 sm:p-6 rounded-2xl shadow border flex flex-col items-center h-full">
              <h2 className="text-2xl mb-3 font-bold text-center text-green-600">
                Free Trial
              </h2>
              <div className="flex flex-col items-center gap-1 mb-4">
                <span className="text-lg font-semibold text-gray-700">
                  300 downloads/month
                </span>
                <span className="text-lg font-semibold text-gray-700">
                  50 concurrency
                </span>
              </div>
              <button
                onClick={() => handleGetFreemiumSubscription("tiktok", userStore, navigate)}
                className="px-4 py-3 text-white rounded-lg bg-green-500 hover:bg-green-700 w-full"
              >
                Get Free Trial
              </button>
            </div>
          </div>
          {plans.map((plan, idx) => (
            <div key={idx} className="flex flex-col w-full min-w-[220px] max-w-xs mx-auto">
              <SubscriptionPriceCard
                scheme="pink"
                title={`TikTok Plan #${idx + 1}`}
                service_callback="tiktok"
                requests_limit={plan.requests_limit}
                concurrency={plan.concurrency}
                unit_price={plan.unit_price}
                price={plan.price}
                started_at={plan.started_at}
                expired_at={plan.expired_at}
              />
            </div>
          ))}
        </div>
      </div>

      {/* Custom Concurrency Plan */}
      <div className="flex flex-col items-center gap-4 mt-8 w-full">
        <h2 className="text-xl font-semibold text-gray-700 text-center">
          Custom Plan
        </h2>
        <p className="text-gray-500 mb-2 text-center max-w-2xl">
          Enter your desired concurrency to preview a personalized TikTok API plan.
        </p>
        <div className="flex flex-col sm:flex-row items-center gap-2 w-full justify-center">
          <label className="font-bold text-lg text-gray-600">
            Concurrency:
          </label>
          <input
            type="number"
            min={1}
            className="w-24 p-2 border-2 border-pink-300 rounded-md text-center focus:ring-2 focus:ring-pink-400"
            value={customConcurrency}
            onChange={(e) => setCustomConcurrency(Number(e.target.value))}
          />
        </div>
        <div className="w-full max-w-md flex justify-center">
          <SubscriptionPriceCard
            scheme="pink"
            title="Custom TikTok Plan"
            service_callback="tiktok"
            requests_limit={customPlan?.requests_limit}
            concurrency={customPlan?.concurrency}
            unit_price={customPlan?.unit_price}
            price={customPlan?.price}
            started_at={customPlan?.started_at}
            expired_at={customPlan?.expired_at}
          />
        </div>
      </div>
    </div>
  );
};

export default TikTokPricing;
